import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Header.css";
import EnquiryPopup from "../components/EnquiryPopup";
// import { toast } from "react-toastify";
import TopScrollBar from "./TopScrollBar";
import { useCart } from "../context/CartContext";

export default function Header() {
  // const base = process.env.PUBLIC_URL || "";

  const [isOpen, setIsOpen] = useState(false);
  const [showEnquiry, setShowEnquiry] = useState(false);
  // const [isLoggedIn, setIsLoggedIn] = useState(false);
  // const [userType, setUserType] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const { cart } = useCart();
  const totalItems = cart.reduce((sum, item) => sum + item.qty, 0);

  useEffect(() => {
    const updatePadding = () => {
      const headerHeight =
        document.querySelector(".premium-navbar")?.offsetHeight || 0;

      const width = window.innerWidth;

      const isHomePage = location.pathname === "/";

      if (isHomePage) {
        if (width <= 576) {
          document.body.style.paddingTop = "35px";
        } else if (width <= 991) {
          document.body.style.paddingTop = "65px";
        } else {
          document.body.style.paddingTop = `${headerHeight + 10}px`;
        }
      } else {
        document.body.style.paddingTop = `${headerHeight + 15}px`;
      }
    };

    updatePadding();
    window.addEventListener("resize", updatePadding);

    return () => {
      document.body.style.paddingTop = "";
      window.removeEventListener("resize", updatePadding);
    };
  }, [location.pathname]);

  /* =========================
     INIT (LOGIN + SCROLL)
  ========================= */
  useEffect(() => {
    // const storedUser = JSON.parse(localStorage.getItem("user"));

    // if (storedUser) {
    //   setIsLoggedIn(true);
    //   setUserType(storedUser.tc_tu_user_type);
    // }

    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  /* =========================
     HANDLERS
  ========================= */
  const toggleNavbar = () => setIsOpen(!isOpen);
  const closeNavbar = () => setIsOpen(false);

  // const handleLogout = () => {
  //   localStorage.clear();
  //   toast.success("Logged out successfully!");
  //   setIsLoggedIn(false);
  //   window.location.href = `${base}/login`;
  // };

  /* =========================
     MENU ITEMS
  ========================= */
  const menuItems = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Product", path: "/products" },
    { name: "FAQs", path: "/faqs" },
    { name: "Blogs", path: "/blogs" },
    { name: "Contact", path: "/contact" },
  ];

  return (
    <>
      <TopScrollBar />
      <nav
        className={`navbar navbar-expand-lg premium-navbar ${
          scrolled ? "scrolled" : ""
        }`}
      >
        <div className="container-fluid px-4">
          <Link
            className="navbar-brand d-flex align-items-center"
            to="/"
            onClick={closeNavbar}
          >
            <img
              src={`${process.env.PUBLIC_URL}/logo_cafesero.png`}
              alt="Logo"
              className="logo-img"
            />
          </Link>

          {/* RIGHT SIDE MOBILE BUTTONS */}
          <div className="d-flex align-items-center gap-2 d-lg-none">
            {/* CART BUTTON */}
            <Link
              to="/cart"
              className="btn btn-book position-relative d-flex align-items-center justify-content-center"
              onClick={closeNavbar}
              style={{
                width: "30px",
                height: "30px",
                padding: "0",
                borderRadius: "5px",
              }}
            >
              <span
                style={{
                  color: "#FFF",
                  fontSize: "24px",
                  lineHeight: "1",
                }}
              >
                🛒
              </span>

              {totalItems > 0 && (
                <span
                  style={{
                    position: "absolute",
                    top: "-5px",
                    right: "-5px",
                    background: "red",
                    color: "#fff",
                    borderRadius: "50%",
                    minWidth: "20px",
                    height: "20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "11px",
                    fontWeight: "bold",
                  }}
                >
                  {totalItems}
                </span>
              )}
            </Link>

            {/* TOGGLER */}
            <button
              className="navbar-toggler d-flex align-items-center justify-content-center"
              type="button"
              onClick={toggleNavbar}
              style={{
                width: "30px",
                height: "30px",
                padding: "0",
                borderRadius: "5px",
              }}
            >
              <span className="navbar-toggler-icon"></span>
            </button>
          </div>

          {/* MENU */}
          <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}>
            {/* LINKS */}
            <ul className="navbar-nav mx-auto" style={{ fontSize: "larger" }}>
              {menuItems.map((item, index) => (
                <li className="nav-item" key={index}>
                  <Link
                    to={item.path}
                    className={`nav-link ${
                      location.pathname === item.path ? "active" : ""
                    }`}
                    onClick={closeNavbar}
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>

            {/* RIGHT SIDE BUTTONS */}
            <div className="d-flex gap-2 flex-column flex-lg-row mt-3 mt-lg-0">
              {/* ENQUIRY POPUP */}
              <EnquiryPopup show={showEnquiry} setShow={setShowEnquiry} />

              {/* AUTH BUTTONS (OPTIONAL) */}
              {/*
              {!isLoggedIn ? (
                <>
                  <Link to="/join" className="btn btn-provider">
                    Join
                  </Link>
                  <Link to="/login" className="btn btn-login">
                    Login
                  </Link>
                </>
              ) : (
                <>
                  <Link
                    to={
                      userType === "provider"
                        ? "/provider/dashboard"
                        : "/user/dashboard"
                    }
                    className="btn btn-dashboard"
                  >
                    Dashboard
                  </Link>
                  <button className="btn btn-logout" onClick={handleLogout}>
                    Logout
                  </button>
                </>
              )}
              */}

              {/* CTA BUTTON */}
              <Link
                to="/cart"
                className="btn btn-book position-relative d-none d-sm-inline-block"
                onClick={closeNavbar}
              >
                Cart
                {totalItems > 0 && (
                  <span
                    style={{
                      position: "absolute",
                      top: "-8px",
                      right: "-8px",
                      background: "red",
                      color: "#fff",
                      borderRadius: "50%",
                      minWidth: "22px",
                      height: "22px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "12px",
                      fontWeight: "bold",
                      padding: "2px",
                    }}
                  >
                    {totalItems}
                  </span>
                )}
              </Link>
              <Link
                to="/products"
                className="btn btn-book"
                onClick={closeNavbar}
              >
                Shop Now
              </Link>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
